import { render, staticRenderFns } from "./formGeneral.pug?vue&type=template&id=543d4468&lang=pug&external"
import script from "./formGeneral.js?vue&type=script&lang=js&external"
export * from "./formGeneral.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543d4468')) {
      api.createRecord('543d4468', component.options)
    } else {
      api.reload('543d4468', component.options)
    }
    module.hot.accept("./formGeneral.pug?vue&type=template&id=543d4468&lang=pug&external", function () {
      api.rerender('543d4468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warrantyLayout/views/warrantyView/components/formGeneral/index.vue"
export default component.exports